import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { SmoothScroll } from "@/components/SmoothScroll";
import { GrainOverlay } from "@/components/GrainOverlay";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Campaign from "@/pages/Campaign";
import Series from "@/pages/Series";
import Videos from "@/pages/Videos";
import Socials from "@/pages/Socials";
import Support from "@/pages/Support";
import TattooTimes from "@/pages/TattooTimes";
import TattooTimesArticle from "@/pages/TattooTimesArticle";
import Merch from "@/pages/Merch";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App min-h-screen bg-ink text-white">
      <BrowserRouter>
        <SmoothScroll>
          <GrainOverlay />
          <ScrollManager />
          <Routes>
            <Route path="/" element={<Campaign />} />
            <Route path="/home" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/series" element={<PublicLayout><Series /></PublicLayout>} />
            <Route path="/videos" element={<PublicLayout><Videos /></PublicLayout>} />
            <Route path="/socials" element={<PublicLayout><Socials /></PublicLayout>} />
            <Route path="/support" element={<PublicLayout><Support /></PublicLayout>} />
            <Route path="/tattoo-times" element={<PublicLayout><TattooTimes /></PublicLayout>} />
            <Route path="/tattoo-times/:slug" element={<PublicLayout><TattooTimesArticle /></PublicLayout>} />
            {/* Hidden — intentionally NOT in navigation */}
            <Route path="/merch" element={<PublicLayout><Merch /></PublicLayout>} />
            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <Toaster />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
